import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@material-ui/icons/Check";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import { useAuth } from "./../util/auth";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(3),
  },
  price: {
    display: "flex",
    alignItems: "baseline",
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2,
  },
  perkIcon: {
    minWidth: 34,
    color: theme.palette.success.main,
  },
}));

function PricingSection(props) {
  const classes = useStyles();

  const auth = useAuth();

  const plans = [
    {
      id: "starter",
      name: "Monthly",
      price: "5.00",
      perks: [
        "AI powered Age Group Content Filtering",
        "Schedules",
        "Viewing History Dashboard",
        // "(Coming soon) Daily Email Reports",
      ],
    },
    {
      id: "pro",
      name: "Annual",
      price: "50",
      perks: [
        "AI powered Age Group Content Filtering",
        "Schedules",
        "Viewing History Dashboard",
        // "(Coming soon) Daily Email Reports",
      ],
    },
    // {
    //   id: "business",
    //   name: "Business",
    //   price: "0.01",
    //   perks: [
    //     // "Lorem ipsum dolor sit amet",
    //     // "Consectetur adipiscing elit",
    //     // "Integer molestie lorem at massa",
    //     // "Faucibus porta lacus fringilla vel",
    //     // "Aenean sit amet erat nunc",
    //     // "Lorem ipsum dolor sit amet",
    //     // "Consectetur adipiscing elit",
    //   ],
    // },
  ];

  // <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
  // <stripe-pricing-table pricing-table-id="prctbl_1N16FMLqp4MZCqzpZty6S7r8"
  // publishable-key="pk_test_51N15XPLqp4MZCqzpWcTijtQshSgxcBrzOQaxmHbynsrBMtCJO7WlRBB3Wr8b1vEhqsZ9zw61yhAStTVsQH1P7Y7800KNZ798g5">
  // </stripe-pricing-table>

  return (
    <Section bgColor={props.bgColor} size={props.size} bgImage={props.bgImage} bgImageOpacity={props.bgImageOpacity}>
      <Container>
        <SectionHeader title={props.title} subtitle={props.subtitle} size={4} textAlign="center" />
        <Grid container={true} justifyContent="center" spacing={4} mb={4}>

          <Box m={4}>
        <Typography variant="h5" color="textSecondary" >
          Choose to pay monthly or yearly. All plans include a 7-day free trial."
        </Typography>
      </Box>
        </Grid>
        <Grid container={true} justifyContent="center" spacing={4}>
          {plans.map((plan, index) => (
            <Grid item={true} xs={12} md={4} key={index}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="h6" component="h2">
                    {plan.name}
                  </Typography>
                  <Box className={classes.price} mt={1}>
                    <Typography variant="h3">${plan.price}</Typography>
                    <Typography variant="h4" color="textSecondary">
                      {plan.name == "Monthly" ? "/mo" : "/yr"}
                    </Typography>
                  </Box>

                  {plan.description && (
                    <Box mt={2}>
                      <Typography component="p" color="textSecondary">
                        {plan.description}
                      </Typography>
                    </Box>
                  )}

                  {plan.perks && (
                    <Box mt={1}>
                      <List aria-label="perks">
                        {plan.perks.map((perk, index) => (
                          <ListItem className={classes.listItem} disableGutters={true} key={index}>
                            <ListItemIcon className={classes.perkIcon}>
                              <CheckIcon />
                            </ListItemIcon>
                            <ListItemText>{perk}</ListItemText>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  )}

                  <Box mt="auto" pt={3}>
                    <Button
                      component={Link}
                      to={auth.user ? `/purchase/${plan.id}` : `/auth/signup?next=/purchase/${plan.id}`}
                      variant="contained"
                      color="primary"
                      size="large"
                      fullWidth={true}
                    >
                      Choose
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

export default PricingSection;
